import { requireEnv } from '@/lib/env';
import type { paths } from '@/services/api-allo/api-allo-remote';
import { fetchWithAuth } from '@/services/api-allo/fetch-with-auth';
import createFetchClient from 'openapi-fetch';
import createClient from 'openapi-react-query';

const BASE_URL = import.meta.env.VITE_API_ALLO_URL;

requireEnv('VITE_API_ALLO_URL', BASE_URL);

export const $fetchAlloRemote = createFetchClient<paths>({
  baseUrl: BASE_URL,
  fetch: fetchWithAuth,
});

export const $apiAlloRemote = createClient($fetchAlloRemote);
